import React from "react";
import Button from "../../../form/Button";

const SectionTable = ({ data }) => {
  return (
    <>
      <div className="py-10 space-y-6">
        {data?.title && data?.subdata?.length > 0 && (
          <h4 className="text-center md:text-left text-2xl xls:text-3xl font-semibold">
            {data?.title}
          </h4>
        )}
        {data?.subdata?.length > 0 && (
          <div className="w-full max-h-[calc(16rem+2px)] overflow-auto scrollbar border border-shades-05">
            <table className="border-collapse w-full">
              <thead className="sticky top-0 bg-white z-[1]">
                <tr className="border-b border-shades-05">
                  <th className="border-l border-shades-05 first:border-l-0 h-16 md:h-16 px-3 text-center w-12">
                    <div className="flex text-base xls:text-2xl font-CanelaDeck gap-2 items-center justify-center">
                      No.
                    </div>
                  </th>
                  <th className="border-l border-shades-05 first:border-l-0 h-16 px-3 text-left">
                    <div className="flex text-base xls:text-2xl font-CanelaDeck gap-2 items-center">
                      <i className="fa-regular fa-fw fa-file-lines text-chestnut-rose"></i>{" "}
                      Document
                    </div>
                  </th>
                  <th className="border-l border-shades-05 first:border-l-0 h-16 px-3 text-left">
                    <div className="flex text-base xls:text-2xl font-CanelaDeck gap-2 items-center">
                      <span className="fa-stack text-xs text-chestnut-rose">
                        <i className="fa-fw fa-regular fa-expand fa-stack-2x"></i>
                        <i className="fa-fw fa-solid fa-arrow-down-left-and-arrow-up-right-to-center fa-stack-1x text-xs"></i>
                      </span>
                      File Size
                    </div>
                  </th>
                  <th className="border-l border-shades-05 first:border-l-0 h-16 px-3 text-left">
                    <div className="flex text-base xls:text-2xl font-CanelaDeck gap-2 items-center">
                      <i className="fa-regular fa-fw fa-arrow-down-to-line text-chestnut-rose"></i>{" "}
                      Download
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {data?.subdata?.map((item, index) => (
                  <tr
                    key={index}
                    className="border-b border-shades-05 last:border-b-0"
                  >
                    <td className="border-l border-shades-05 first:border-l-0 h-16 md:h-16 px-3 text-center w-12">
                      <div className="flex items-center justify-center font-CanelaDeck text-sm md:text-xl xls:text-2xl font-semibold">
                        {String(index + 1).padStart(2, "0")}
                      </div>
                    </td>
                    <td className="border-l border-shades-05 first:border-l-0 h-16 px-3 text-left">
                      <div className="flex items-center font-CanelaDeck text-xs md:text-base xls:text-xl">
                        {item?.title}
                      </div>
                    </td>
                    <td className="border-l border-shades-05 first:border-l-0 h-16 px-3 text-left">
                      <div className="flex items-center font-CanelaDeck text-xs md:text-base xls:text-xl">
                        {item?.size}
                      </div>
                    </td>
                    <td className="border-l border-shades-05 first:border-l-0 h-16 px-3 text-left">
                      <div className="flex items-center font-CanelaDeck text-xs md:text-base xls:text-xl">
                        {item?.action && (
                          // <a href={item?.action?.link} target="_blank" rel="noreferrer" download className="">
                          //   {item?.action?.label}
                          // </a>
                          <Button
                            buttonHasLink={item?.action?.link}
                            buttonLink={item?.action?.link}
                            buttonLabel={item?.action?.label}
                            target="_blank"
                            buttonClasses={
                              "!h-10 !gap-0 md:!gap-2 !px-[4px] md:!px-3"
                            }
                            buttonIcon={"fa-regular fa-file-arrow-down"}
                            buttonIconPosition={"left"}
                            buttonLabelClasses={
                              "!text-[11px] lg:text-base xls:!text-xl !font-CanelaDeck"
                            }
                          />
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
};

export default SectionTable;
